export const SET_ALL_EPISODES = 'SET_ALL_EPISODES'
export const SET_CURRENT_EPISODE = 'SET_CURRENT_EPISODE'
export const SET_CURRENT_AUDIO = 'SET_CURRENT_AUDIO'
export const SET_ALL_EPISODES_ERROR = 'SET_ALL_EPISODES_ERROR'
export const INCREMENT_NUMBER_OF_TRIES = 'INCREMENT_NUMBER_OF_TRIES'
